module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-25.da5e74fc.jpg";